module.exports = __webpack_public_path__ + "img/CECA_Treg.81df8991.png";